import React from 'react';
import './did_you_know.scss';
import { Container, Typography } from '@material-ui/core';
import DidYouKnowDialogContent from './../dialogs/dialog_did_you_know';

const DidYouKnow = () => {
  return (
    <div className="App_did_you_know">
      <Container maxWidth="md">
        <Typography variant="h2">Did you know?</Typography>
        <p>
          Modern Mutual insurance arose from ships returning to London in the
          17th century. If your ship was sunk, the losses were high. Thus was
          born the modern mutual insurance&nbsp;model.
        </p>

        <DidYouKnowDialogContent />
      </Container>
    </div>
  );
};

export default DidYouKnow;
